@use "variables" as *;

.name {
  height: 100%;
  text-align: center;
  font-size: $fontSize-s;
}

.skeleton {
  width: 100%;
  border-radius: 20px;
}
